import cx from 'classnames';
import { useIntl } from 'react-intl';

import { Author } from '../../../resources/author/domain/types/author';
import { useUrlGenerator } from '../../hooks/useUrlGenerator';
import { convertDateToUTC } from '../../utilities/date';
import { PickDomain } from '../../utilities/types/PickDomain';

import style from './ArticleAuthorWithDate.module.css';

export function ArticleAuthorWithDate({
    author,
    date,
    className,
}: {
    className?: string;
    author: PickDomain<Author, 'firstName' | 'lastName' | 'id' | 'slug'>;
    date: string | null;
}) {
    const { formatMessage } = useIntl();
    const { generatePath } = useUrlGenerator();

    const utcDate = date ? convertDateToUTC(new Date(date)) : null;

    return (
        <div className={cx(style.container, className)}>
            <div>
                {formatMessage(
                    { id: 'page.author.byAuthor' },
                    {
                        authorFirstName: author.firstName,
                        authorLastName: author.lastName,
                        a: (chunks) => (
                            <a
                                className="link"
                                href={generatePath('author', {
                                    authorId: author.id,
                                    authorSlug: author.slug,
                                })}
                            >
                                {chunks}
                            </a>
                        ),
                    },
                )}
            </div>

            {utcDate ? (
                <>
                    <div>·</div>
                    <time
                        dateTime={utcDate.toISOString()}
                    >{`${day(utcDate)}/${month(utcDate)}/${year(utcDate)}`}</time>
                </>
            ) : null}
        </div>
    );
}

function day(date: Date) {
    return date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
}

function month(date: Date) {
    return date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
}

function year(date: Date) {
    return date.getFullYear();
}
